import { useTranslation } from "react-i18next";

// Bottone "Applica altri filtri" condiviso.
// Apre la modale AllFilters tramite il callback onClick.
// Mostra un contatore dei filtri attivi se activeCount > 0.
const FiltersButton = ({ onClick, activeCount = 0 }) => {
    const { t } = useTranslation();
    return (
        <div
            onClick={onClick}
            className="md:m-4 py-1 px-2 border rounded-xl cursor-pointer bg-neutral-100 hover:bg-[#e2eeed] flex gap-2 items-center text-sm"
        >
            <div className="mt-1">
                <i className="fi fi-rr-settings-sliders"></i>
            </div>
            <div>{t('poolBar.otherFiltersCopy')}</div>
            {activeCount > 0 && (
                <div className="underline text-[#225424] font-bold rounded-full">
                    ({t('poolBar.filtersActiveCount', { count: activeCount })})
                </div>
            )}
        </div>
    );
};

export default FiltersButton;
